import React, { createContext, useContext, useEffect, useState} from 'react'
import api from '../services/api'

interface ILoadingContext {
    isLoading: Boolean
}

const LoadingContext = createContext<ILoadingContext>({} as ILoadingContext)

const LoadingProvider: React.FC = ({ children}) => {
  const [pendingRequests, setPendingRequests] = useState(0);

  useEffect(() => {
    const requestInterceptor = api.interceptors.request.use(config => {
      setPendingRequests(count => count + 1);
      return config;
    });

    const responseInterceptor = api.interceptors.response.use(
      response => {
        setPendingRequests(count => count - 1);
        return response;
      },
      error => {
        setPendingRequests(count => count - 1);
        return Promise.reject(error);
      },
    );

    return () => {
      api.interceptors.request.eject(requestInterceptor);
      api.interceptors.response.eject(responseInterceptor);
    };
  }, []);

  return (
    <LoadingContext.Provider value={{ isLoading: pendingRequests > 0 }}>
      {children}
    </LoadingContext.Provider>
  );
}

function useLoading(): ILoadingContext {
  const context = useContext(LoadingContext);

  if (!context) {
    throw new Error('useLoading must be used within a LoadingProvider');
  }

  return context;
}

export { LoadingProvider, useLoading };